import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Location, AsyncPipe } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { SearchService } from '../../services/search.service';
import { TitleService } from '../../services/title.service';
import { BreadcrumbService } from '../../services/breadcrumb.service';
import { Subscription } from 'rxjs';
import { BreadCrumbComponent } from '../breadcrumb/breadcrumb.component';
import { SearchResultComponent } from '../search-result/search-result.component';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    imports: [BreadCrumbComponent, SearchResultComponent, AsyncPipe]
})
export class SearchComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private location = inject(Location);
  private route = inject(ActivatedRoute);
  private titleService = inject(TitleService);
  private breadcrumbService = inject(BreadcrumbService);
  searchService = inject(SearchService);


  term: string;
  subscription: Subscription;

  ngOnInit() {
    this.subscription = this.route.queryParams.subscribe(params => {
      const { term } = params;
      this.term = term;
      this.render();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  render(): void {
    this.titleService.set(`Search results for: "${this.term}"`);
    this.breadcrumbService.set(`Search`);
    this.searchService.search(this.term);
  }
}
